$(function() {

	$.nette.ext('basket', {
		init: function() {
			this.init();
		},
		success: function() {
			this.init();
		}
	}, {
		init: function() {

			$('#basket')
				.filter(function() {
					return ! $(this).data('initialized');
				})
				.each(function () {
					var $box = $(this);

					$box.data('initialized', true);

					if ($box.find('.ca-box').length) {
						$box
							.on('expand.collapsable', function() {
								var $control = $(this).find('.ca-control .mob-label');
								$control.html($control.data('collapse'));
							})
							.on('collapse.collapsable', function() {
								var $control = $(this).find('.ca-control .mob-label');
								$control.html($control.data('expand'));
							})
							.on('collapsed.collapsable', function(e) {
								if( e.collapsableEvent.type === 'init.collapsable' ) {
									var $control = $(this).find('.ca-control .mob-label');
									$control.html($control.data('expand'));
								}
							})
							.collapsable({
								control: '.ca-control',
								box: '.ca-box',
								fx: 'slide'
							});
					}
				});

		}
	});

});
